export default __webpack_public_path__ + "static/media/088.74e60f13.jpg";